import m from './module';
import {
  LogicCondition,
  logicOptions,
  logicOptionsWithoutComparisons,
  dateLogicOptions,
} from '../model/LogicCondition';
import { createError } from '../error';
import {
  formatAsTimeString,
} from '../dateutil';

class LogicConditionService {
  constructor(
    $injector,
    $q,
    DateTimeService,
    LogService
  ) {
    "ngInject";
    this.$injector = $injector;
    this.$q = $q;
    this.DateTimeService = DateTimeService;
    this.LogService = LogService;
  }

  create(data) {
    data = data || {};
    let target_id = data.target_id || null;
    if (!target_id) {
      target_id = data.references_events_custom_instances_id || null;
    }
    data.target_id = target_id;

    return new LogicCondition(data);
  }

  serialize(logicCondition) {
    const targetFieldType = logicCondition
      && logicCondition.target
      && logicCondition.target.field
      && logicCondition.target.field.fieldType;

    /**
     * Serialize date/time for API; removes timezone
     */
    let serializedValue = logicCondition.value;
    if (targetFieldType && targetFieldType.isDateTime) {
      serializedValue = this.DateTimeService.serializeDateTimeForAPI(logicCondition.value);
    } else if (targetFieldType && targetFieldType.isTime) {
      const useAmPm = true;
      serializedValue = formatAsTimeString(logicCondition.value, useAmPm);
      this.LogService.debug(`LogicConditionService.serialize() input: ${logicCondition.value} output: ${serializedValue}`);
    } else if (targetFieldType && targetFieldType.isDate) {
      serializedValue = this.DateTimeService.serializeDateForAPI(logicCondition.value);
    }

    return {
      id: logicCondition.id,
      references_events_custom_instances_id:
        (logicCondition.target && logicCondition.target.id) || logicCondition.target_id,
      logic: logicCondition.logic,
      value: serializedValue,
      selected_option_identifier: logicCondition.selected_option_identifier,
    };
  }

  describeLogic(logic) {
    if (logic in this.logicOptions) {
      return this.logicOptions[logic];
    } else {
      return logic;
    }
  }

  get logicOptions() {
    return logicOptions;
  }

   get dateLogicOptions() {
    return dateLogicOptions;
  }

  get logicOptionsWithoutComparisons() {
    return logicOptionsWithoutComparisons;
  }

  updateTargetForLogicCondition(logicCondition) {
    return this.$q.when(logicCondition)
      .then(condition => {
        if (condition && condition.target_id) {
          if (!!condition.target) {
            this.updateValueForLogicConditionWithTarget(condition, condition.target);
            return this.$q.resolve(condition.target)
              .then(() => condition.target);
          }
          const FieldInstanceService = this.$injector.get('FieldInstanceService');
          const fieldInstancePromise = FieldInstanceService.getById(condition.target_id);
          return this.$q.when(fieldInstancePromise)
            .then(targetFieldInstance => {
              condition.target = targetFieldInstance;
              this.updateValueForLogicConditionWithTarget(condition, targetFieldInstance);
              return this.$q.resolve(condition.target)
                .then(() => targetFieldInstance);
            })
            .catch(err => {
              this.LogService.warn("Error retrieving target field instance or updating value:", err);
            })
        }
        return this.$q.reject(createError({
          error: 'MissingTargetForLogicCondition',
          message: 'Logic condition has no target ID',
          condition,
        }));
      })
      .catch(err => {
        this.LogService.warn("Error fetching logic condition:", err);
      });
  }

  updateValueForLogicConditionWithTarget(logicCondition, targetFieldInstance) {
    const field = targetFieldInstance && targetFieldInstance.field;
    const fieldType = field && field.fieldType;

    if (field && field.hasOptions() && logicCondition.selected_option_identifier) {
      // Find selected option if it exists, and populate
      logicCondition.valueOption = targetFieldInstance.field.options.find(option => String(option.id) === String(logicCondition.selected_option_identifier));
    } else if (fieldType && (fieldType.isDate || fieldType.isDateTime)) {
      // // Use DateService to parse the logic condition's date
      // const dateValue = this.DateTimeService.parseDateTimeStringFromAPI(logicCondition.value);
      // if (fieldType.isDateTime) {
      //   logicCondition.value = dateValue;
      // } else if (fieldType.isDate) {
      //   logicCondition.value = castToDateWithoutTime(dateValue);
      // }
    } else if (fieldType && fieldType.isTime) {
      // const timeValue = this.DateTimeService.parseTimeStringFromAPI(logicCondition.value);
      // logicCondition.value = timeValue;
    }
  }
}

export default LogicConditionService;

m.service('LogicConditionService', LogicConditionService);
